/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_CustomInputs */

const en_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Format Custom...`)
};

const fr_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format auto personnalisé...`)
};

const de_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung Benutzerdefiniert...`)
};

const it_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione automatica personalizzata...`)
};

const ru_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование...`)
};

const es_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático personalizado...`)
};

const zh_cn2_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化自定义...`)
};

const ja_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマットカスタム...`)
};

const hi_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम फॉर्मेट को स्वचालित रूप से फॉर्मेट करें...`)
};

const pt_pt2_auto_format_custom = /** @type {(inputs: Auto_Format_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática personalizada...`)
};

/**
* | output |
* | --- |
* | "Auto Format Custom..." |
*
* @param {Auto_Format_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_custom = /** @type {((inputs?: Auto_Format_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_custom(inputs)
	if (locale === "de") return de_auto_format_custom(inputs)
	if (locale === "it") return it_auto_format_custom(inputs)
	if (locale === "ru") return ru_auto_format_custom(inputs)
	if (locale === "es") return es_auto_format_custom(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_custom(inputs)
	if (locale === "ja") return ja_auto_format_custom(inputs)
	if (locale === "hi") return hi_auto_format_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_custom(inputs)
	return en_auto_format_custom(inputs)
});